import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface KpoLogosComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-kpo-logos",
    templateUrl: "./kpo-logos.component.html",
    styleUrls: ["./kpo-logos.component.scss"],
    providers: [LocalComponentStore],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpoLogosComponent {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<KpoLogosComponentState>) {
        this.localStore.setState({
            activeLanguage: undefined,
        });
    }
}
